export default "__VITE_ASSET__22c080bb__"